import { z } from 'zod';
import { ESPECIALIDADES } from '../catalogos/especialidades.js';
import { esquemaId, esquemaMotivo } from './comunes.js';
import { esquemaInstante } from './cita.js';
/**
 * Encuentro clinico (F2.1, plan maestro §5.2).
 *
 * La cita es una reserva; el encuentro es la atencion. Se puede atender sin
 * cita, y cancelar la cita no borra un encuentro ya documentado. Cerrar el
 * encuentro NO firma sus documentos: cada uno tiene su propio ciclo.
 */
export const ESTADOS_DE_ENCUENTRO = [
    'programado',
    'en-atencion',
    'pendiente-cierre',
    'cerrado',
    'cancelado',
];
export const NOMBRE_DE_ESTADO_DE_ENCUENTRO = {
    programado: 'Programado',
    'en-atencion': 'En atención',
    'pendiente-cierre': 'Pendiente de cierre',
    cerrado: 'Cerrado',
    cancelado: 'Cancelado',
};
/**
 * A donde puede pasar cada estado. `cerrado` y `cancelado` son finales: un
 * encuentro cerrado se corrige con un documento nuevo o una aclaracion, no
 * reabriendolo. Solo se cancela lo que todavia no se atendio.
 */
export const TRANSICIONES_DE_ENCUENTRO = {
    programado: ['en-atencion', 'cancelado'],
    'en-atencion': ['pendiente-cierre', 'cerrado'],
    'pendiente-cierre': ['en-atencion', 'cerrado'],
    cerrado: [],
    cancelado: [],
};
export function puedeTransitar(desde, hacia) {
    return TRANSICIONES_DE_ENCUENTRO[desde].includes(hacia);
}
export const CONTEXTOS_DE_ENCUENTRO = [
    'consulta',
    'seguimiento',
    'procedimiento',
    'urgencia',
    'teleconsulta',
];
export const esquemaCrearEncuentro = z
    .object({
    pacienteId: esquemaId,
    /** Opcional: se puede atender sin cita. */
    citaId: esquemaId.optional(),
    especialidad: z.enum(ESPECIALIDADES),
    /** Sin valor, el servidor asigna a quien crea el encuentro. */
    profesionalId: esquemaId.optional(),
    /** Tiempo clinico: cuando ocurre la atencion, no cuando se registra. */
    fechaHora: esquemaInstante,
    contexto: z.enum(CONTEXTOS_DE_ENCUENTRO).default('consulta'),
    motivo: z.string().trim().max(500).default(''),
    /** Un encuentro nace programado o, si se atiende sin cita, ya en atencion. */
    estado: z.enum(['programado', 'en-atencion']).default('programado'),
})
    .strict();
export const esquemaCambiarEstadoEncuentro = z
    .object({
    estado: z.enum(ESTADOS_DE_ENCUENTRO),
    /** Concurrencia optimista: 409 si otro lo cambio antes (plan §13.4). */
    versionEsperada: z.number().int().min(0),
    motivo: esquemaMotivo.optional(),
})
    .strict()
    .refine((cambio) => cambio.estado !== 'cancelado' || cambio.motivo !== undefined, {
    message: 'Cancelar un encuentro exige motivo',
    path: ['motivo'],
});
export const esquemaListarEncuentros = z.object({
    pacienteId: esquemaId.optional(),
    estado: z.enum(ESTADOS_DE_ENCUENTRO).optional(),
    pagina: z.coerce.number().int().min(1).default(1),
    porPagina: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=encuentro.js.map